import { SearchLocationsGQL } from 'src/generated/graphql';
import { SearchLocationInput } from '../../models/search-location-input';
import { Injectable } from '@angular/core';

@Injectable()
export class LocationService {
  constructor(private searchLocationsGQL: SearchLocationsGQL) {}

  public getLocations(input: SearchLocationInput) {
    return this.searchLocationsGQL.fetch(input, { fetchPolicy: 'network-only' });
  }
}
